
import Vue from "vue";
import store from "@/store";
import LINK from "@/utils/link";
import AppModal from "@/components/UI/AppModal.vue";
import AppWarning from "@/components/UI/AppWarning.vue";
import AppModalBtn from "@/components/UI/AppModalBtn.vue";
import { separateDigits, convertToPersian } from "@/utils/string";

export default Vue.extend({
  name: "ProfileCart",
  components: {
    AppWarning,
    AppModal,
    AppModalBtn,
  },
  data() {
    return {
      modal: false,

      LINK: LINK,
      imgPrefix: "images/upload-product-images/",

      totalAmount: 0,

      payModal: false,
      payModalText: "",

      isValid: true,

      address: "",
    };
  },
  methods: {
    separateDigits,
    convertToPersian,
    submitProducts() {
      this.modal = true;

      // compare total amount with user wallet balance
      if (this.totalAmount > (store.state.panel.user?.wallet || 0)) {
        this.isValid = false;
        this.modal = false;
        this.payModal = true;
        this.payModalText = "موجودی کیف‌پول شما کافی نیست.";
      }

      // check user address
      if (store.state.panel.user?.address.length) {
        this.isValid = true;
      } else if (this.address.length) {
        this.isValid = true;
      } else {
        this.isValid = false;
      }
    },
    payWithWallet() {
      this.modal = false;

      // add new invoice
      if (this.isValid) {
        let productslist = [];

        for (let i in this.products) {
          const product = this.products[i];
          productslist.push({ productId: product.id, qty: product.qty });
        }

        const data = {
          products: productslist,
          address: store.state.panel.user?.address
            ? store.state.panel.user.address
            : this.address,
        };

        store.dispatch("panel/addNewInvoice", {
          data,
          totalAmount: this.totalAmount,
        });
      }
    },
    removeProduct(id: string) {
      store.dispatch("panel/removeCartItem", id);
    },
    // calculate
    calTotalAmount(): void {
      for (let i in this.products) {
        const product = this.products[i];
        if (product.special_sell !== 0) {
          this.totalAmount =
            this.totalAmount + product.special_sell * product.qty;
        } else {
          this.totalAmount = this.totalAmount + product.amount * product.qty;
        }
      }
    },
  },
  mounted() {
    this.calTotalAmount();
  },
  computed: {
    products(): any[] {
      return store.state.panel.cart;
    },
  },
});
